import React from 'react';
import { FaUsers, FaCheck, FaClock } from 'react-icons/fa';
import { IoCalendarSharp } from 'react-icons/io5';

const RotaStats = () => {
  const stats = [
    { 
      icon: FaUsers, 
      title: 'Total Assignments', 
      second_title: 'This Week', 
      value: '23',
      color: 'text-blue-600 bg-blue-50'
    },
    { 
      icon: FaCheck, 
      title: 'Completed', 
      second_title: '91% completion rate', 
      value: '21',
      color: 'text-green-600 bg-green-50'
    },
    { 
      icon: FaClock, 
      title: 'Pending', 
      second_title: '9 items remaining', 
      value: '2',
      color: 'text-amber-600 bg-amber-50'
    },
    { 
      icon: IoCalendarSharp, 
      title: 'Checks', 
      second_title: 'This Week', 
      value: '4',
      color: 'text-purple-600 bg-purple-50'
    },
  ];

  return (
    <section className="mt-10">
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
        {stats.map((stat, index) => {
          const IconComponent = stat.icon;
          return (
            <div 
              key={index} 
              className="bg-white border border-slate-100 rounded-xl p-5 flex items-center justify-between shadow-sm hover:shadow-md transition-shadow duration-200"
            >
              <div className={`p-3 rounded-lg ${stat.color} flex items-center justify-center`}>
                <IconComponent className="w-6 h-6" />
              </div>
              <div className="space-y-1">
                <p className="text-3xl font-bold text-slate-800">
                  {stat.value}
                </p>
                <p className="text-sm font-medium text-slate-500 tracking-wide uppercase">
                  {stat.title}
                </p>
                <p className="text-xs text-slate-400 font-light">
                  {stat.second_title}
                </p>
              </div>
              
            </div>
          );
        })}
      </div>
    </section>
  );
};

export default RotaStats;
